
import { AuthContext, useAuth } from './AuthContext';

function RequireAuth({ children }) {
  const user = useAuth(); // Récupère l'état d'authentification

  // user non authentifié
  if (user === null) {
    //return <Authent />
  }

  // Utilisateur authentifié, on rend le composant enfant demandé (la page protégée)
  return (
    <AuthContext value={user}>
      {children}
    </AuthContext>
  );
}

export default RequireAuth;